import { ACTION_LABEL } from "@/lib/i18nLabels";
import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";
import Combobox from "@/components/Combobox";
import ClientAutocomplete from "@/components/ClientAutocomplete";
import { INDONESIA_REGIONS, PROVINCES } from "@/lib/indonesia";
import api, { formatDetail } from "@/lib/api";

const emptyOutlet = { project_name: "", client: "", province: "", city: "" };

export default function NewOutletForm({ parents, onDone, onCancel }) {
  const [outlet, setOutlet] = useState(emptyOutlet);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!outlet.project_name.trim()) { toast.error("Nama Outlet wajib diisi"); return; }
    if (!outlet.client.trim()) { toast.error("Client wajib diisi"); return; }
    setBusy(true);
    try {
      await api.post("/active-projects", {
        project_type: "new_project",
        is_outlet: true,
        project_name: outlet.project_name.trim(),
        client: outlet.client.trim(),
        city: outlet.city || null,
        province: outlet.province || null,
      });
      toast.success("Outlet dibuat sebagai parent project");
      onDone?.();
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="outlet-form">
      <div className="bg-amber-50 border-l-2 border-amber-500 px-3 py-2 text-[11px] text-amber-900 leading-snug">
        Outlet berfungsi sebagai <span className="font-semibold">Parent Project</span> — nantinya menampung Variation Order &amp; Working Order per pekerjaan. Isi hanya identitas outlet; nilai kontrak &amp; tanggal diisi di masing-masing WO.
      </div>
      <div className="space-y-1.5">
        <Label className="overline text-slate-600">Nama Outlet</Label>
        <Input data-testid="outlet-name" required value={outlet.project_name} onChange={(e) => setOutlet({ ...outlet, project_name: e.target.value })} className="rounded-none" placeholder="e.g. RKI - RF Gajah Mada" />
      </div>
      <div className="space-y-1.5">
        <Label className="overline text-slate-600">Client</Label>
        <ClientAutocomplete
          testid="outlet-client"
          required
          value={outlet.client}
          onChange={(v) => setOutlet({ ...outlet, client: v })}
          options={parents.map((p) => p.client || "")}
          placeholder="Ketik / pilih dari client sebelumnya…"
        />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-1.5">
          <Label className="overline text-slate-600">Province</Label>
          <Combobox testid="outlet-province" value={outlet.province} onChange={(v) => setOutlet({ ...outlet, province: v, city: "" })} options={PROVINCES} placeholder="Select province…" />
        </div>
        <div className="space-y-1.5">
          <Label className="overline text-slate-600">City / Regency</Label>
          <Combobox testid="outlet-city" value={outlet.city} onChange={(v) => setOutlet({ ...outlet, city: v })} options={outlet.province ? INDONESIA_REGIONS[outlet.province] || [] : []} placeholder={outlet.province ? "Select city…" : "Pick province first"} disabled={!outlet.province} />
        </div>
      </div>
      <DialogFooter>
        <Button type="button" variant="outline" className="rounded-none" onClick={onCancel}>{ACTION_LABEL.cancel}</Button>
        <Button type="submit" data-testid="outlet-submit" disabled={busy} className="rounded-none bg-[#FF5A1F] hover:bg-[#e04a13]">
          {busy ? "Saving…" : "Save Outlet"}
        </Button>
      </DialogFooter>
    </form>
  );
}
